<div class="layout-wrapper">
    <ng-content></ng-content>
</div>
